import { useState } from 'react';
import { TextArea, TextBox } from '../../shared/controls/form';
import SelectBox from '../../shared/controls/form/selectBox';
import { Formik } from 'formik';

const AddProfile = ({ selectedOptions, handleClose, handleChange }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [errorMsg, setErrorMsg] = useState('');

  const options = [
    { value: 'administrator', label: 'Administrator' },
    { value: 'manager', label: 'Manager' },
    { value: 'salesManager', label: 'Sales Manager' },
  ];
  const handleSelect = (selected) => {
    setSelectedOption(selected);
    setErrorMsg(''); // Clear error message on selection
  };

  return (
    <Formik>
      <form>
        <div id="genricPopup">
          <div className="popup-backdrop ">
            <div className="popup">
              {/* Popup Header */}
              <div className="popup-header">
                <h4 className="popup-title">Create New Profile</h4>
                <button className="custom-btn-close" onClick={handleClose}></button>
              </div>

              {/* Popup Body */}
              <div className="popup-body">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-6">
                    <div className="input-container">
                      <TextBox
                        // isRequired={true}
                        label={'Profile Name'}
                        name={'profileName'}
                        placeholder={'Enter Profile Name'}
                        value={''}
                        handleChange={''}
                        maxLength={250}
                        errormsg={''}
                        disabled={''}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6">
                    <div className="input-container">
                      <SelectBox
                        label={'Clone Profile'}
                        name={'cloneProfile'}
                        placeholder={'Select'}
                        isRequired={false}
                        disabled={''}
                        selectedOptions={selectedOption}
                        handleSelect={handleSelect}
                        options={options}
                        errormsg={errorMsg}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12">
                    <div className="input-container addProfileTA">
                      <TextArea
                        label={'Profile Description'}
                        name={'profileDescription'}
                        placeholder={'Enter Description'}
                        value={''}
                        handleChange={''}
                        errormsg={''}
                        disabled={''}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Popup Footer */}
              <div className="popup-footer">
                <button type="button" className="cancel-lead ld-btn" onClick={handleClose}>
                  Cancel
                </button>
                <button type="button" className="save-lead ld-btn">
                  Create
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </Formik>
  );
};
export default AddProfile;
